<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="container-fluid">
    <!--h2 class="modal-title">
    <i class="fas fa-search" aria-hidden="true"></i>
    {{ 'SearchGeneric.finder' | translate }} CPVs
  </h2-->
    <!-- FILTRO DEL BUSCADOR -->
    <div class="row">
      <div class="col-12">
        <div class="alert alert-info text-center">
          <span>{{ 'SearchGeneric.select.filters' | translate }}</span>
        </div>
        <div class="form-group">
          <label for="filterText">{{ 'General.search.maxLength' | translate:{maxLength: this.MIN_SEARCH_TEXT_LENGHT}
            }}<span class="m-xs" *ngIf="isLoading()" class="leyenda">
              <i class="fas fa-circle-notch fa-2x loading-spin" aria-hidden="true"></i>

            </span>
          </label>
          <input autofocus id="filterText" type="text" class="form-control  form-control-sm"
            placeholder="{{ 'SearchGeneric.enter.text' | translate }}" [(ngModel)]="filterText"
            (ngModelChange)="changed($event)" (keyup.enter)="updateFilter()" autocomplete="off"
            ng-model-options="{debounce: 750}" autocomplete="off" />
          <button type="button" class="btn btn-secondary btn-sm float-left m-t-sm" data-dismiss="modal"
            (click)="cancel()">
            <i class="fas fa-times" aria-hidden="true"></i> {{ 'General.cancel' | translate }}
          </button>
          <button type="button" class="btn btn-primary btn-sm float-right m-t-sm" [disabled]="filterText.length < 3"
            (click)="updateFilter()">
            <i class="fas fa-search" aria-hidden="true"></i> {{ 'General.search.text' | translate }}
          </button>
        </div>
      </div>
    </div>
    <!-- ARBOL DE DATOS -->
    <div class="row">
      <div class="col-12  m-t-sm m-b-sm">
        <span *ngIf="searchPerformed" class="leyenda float-right "> {{ 'SearchGeneric.found' | translate }}
          {{getItemCount()}}</span>
      </div>
      <div class="col-12 ">
        <ng-container *ngIf="searchPerformed">
          <div class="border-bottom border-top">
            <ng-container *ngIf="treeModel && treeModel.length > 0; else noDataFound">
              <p-tree [value]="treeModel" selectionMode="single" [selection]="selectedObject"
                (onNodeSelect)="accept($event)">
                <ng-template let-node pTemplate="default">
                  <span>

                    <span [innerHTML]="node.label"></span>
                  </span>
                </ng-template>
              </p-tree>
            </ng-container>
            <ng-template #noDataFound>
              <div class="alert alert-info text-center m-t-md">
                <span>
                  <i class="fa fa-info-circle fa-2x float-left" aria-hidden="true"></i>
                  {{ 'SearchGeneric.noDataFound' | translate }}</span>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>
      <!--ng-template #loading>
      <ng-container *ngIf="isLoading(); else notInitialized">
        <span>
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>x
          {{ 'SearchGeneric.finding' | translate }}</span>
      </ng-container>
    </ng-template-->
      <!--ng-template #notInitialized>
      <span>{{ 'SearchGeneric.select.filters' | translate }}</span>
    </ng-template-->
    </div>
  </div>
</p-scrollPanel>